import Text from './builtin_text'
import Card from './builtin_card'
import Carousel from './builtin_carousel'
import Image from './builtin_image'
import SingleChoice from './builtin_single-choice'
import ActionButton from './builtin_action-button'
import Raw from './builtin_raw'

export default {
  builtin_text: Text,
  builtin_card: Card,
  builtin_carousel: Carousel,
  builtin_image: Image,
  builtin_raw: Raw,
  'builtin_single-choice': SingleChoice,
  'builtin_action-button': ActionButton
}
